import "./LessonList.css";
import React from "react";
import { Link } from "react-router-dom";
import { CurrentUserContext } from "../../../contexts/CurrentUserContext";
import check from "../../../image/check-icon.svg";

function LessonList({ lesson, courseId }) {
  const { currentUser } = React.useContext(CurrentUserContext);

  const userId = String(currentUser?._id || "");
  const completedByIds = (lesson.completedBy || []).map(String);
  const availableForIds = (lesson.availableFor || []).map(String);

  const isLessonCompleted = completedByIds.includes(userId);

  // 👇 доступен если публичный ИЛИ явно добавлен
  const isLessonAvailable = lesson.isPublic === true || availableForIds.includes(userId);

  return (
    <li
      key={lesson._id}
      className={`course-summary__subtitle-block course-summary__subtitle-block_active ${
        isLessonAvailable ? "" : "course-summary__subtitle-block_disabled"
      }`}
    >
      <Link
        className={`course-summary__subtitle-link ${
          isLessonAvailable ? "" : "course-summary__subtitle-link_disabled"
        }`}
        to={isLessonAvailable ? `/content/${courseId}/lessons/${lesson._id}` : "#"}
      >
        {isLessonCompleted ? (
          <img src={check} className="course-summary__subtitle-img" alt="иконка" />
        ) : (
          <span className="course-summary__subtitle-img"></span>
        )}
        <h3 className="course-summary__subtitle-title">{lesson.title}</h3>
        {lesson.isPublic && <span className="course-summary__badge">Бесплатно</span>}
      </Link>
    </li>
  );
}

export default LessonList;
